import PackagesPage from '../PackagesPage/PackagesPage'
import LandingPage from './LandingPage/LandingPage'
import { useEffect } from 'react'
import { usePackages, withPackages } from '../../components/PackagesProvider'

const HomePage = () => {
  const packages = usePackages()
  const totalPackages = Object.keys(packages).length

  useEffect(() => {
    if (totalPackages > 0) {
      document.title = 'Geartrack - Packages'
    } else {
      document.title = 'Geartrack - Package Tracking'
    }
  }, [totalPackages])

  if (totalPackages > 0) {
    return <PackagesPage />
  }

  return <LandingPage />
}

export default withPackages(HomePage)
